interface IProps {
  title: string
  content: string[]
}

const Rules = ({ content, title }: IProps) => {
  console.log('rulesContent', content)

  return (
    <div className="onboarding-steps__rules">
      <h2 className="onboarding-steps__rules__title">{title}</h2>
      <div className="onboarding-steps__rules__container">
        {content?.map((rule, index) => {
          return (
            <div key={index} className="onboarding-steps__rules__rule">
              <span style={{ paddingTop: '5px' }}>
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.35938 0.390625L11.6094 4.64062L11.9531 5L11.6094 5.35938L7.35938 9.60938L6.64062 8.89062L10.0312 5.5H0V4.5H10.0312L6.64062 1.10938L7.35938 0.390625Z"
                    fill="white"
                  />
                </svg>
              </span>
              <p>{rule}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Rules
